// extracted by css-extract-rspack-plugin
export default {"wrapper":"_e43867b2","icon":"_4ad5706a","heading":"_30f03ce9","subheading":"_9456724d"};